import React from 'react'
import { Map } from 'immutable'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { withFormsy as HOC } from 'formsy-react'
import { connect } from 'react-redux'
import { Password } from 'components/FormInput.v2'
import { FORM_INPUT_NAME_PASSWORD } from 'services/form'

function LoginPassword ({
  loginPasswordStaticText,
  setValue,
  value,
  autofocus,
}) {
  return (
    <div className="login-password__password-wrapper">
      <Password
        name={FORM_INPUT_NAME_PASSWORD}
        onChange={(newValue) => setValue(newValue)}
        value={value || ''}
        label={loginPasswordStaticText.getIn(['data', 'password'])}
        className={'login-password__password'}
        // eslint-disable-next-line jsx-a11y/tabindex-no-positive
        tabIndex="4"
        showHideTabIndex="5"
        required
        autocomplete="current-password"
        autofocus={autofocus}
      />
    </div>
  )
}

LoginPassword.propTypes = {
  loginPasswordStaticText: ImmutablePropTypes.map.isRequired,
  hasValidation: PropTypes.bool,
  labelText: PropTypes.string,
  hasErrors: PropTypes.bool,
  name: PropTypes.string,
  autofocus: PropTypes.bool,
}

const connectedLoginPassword = HOC(LoginPassword)

export default connect((state) => ({
  loginPasswordStaticText: state.staticText.getIn(
    ['data', 'loginPassword'],
    Map(),
  ),
}))(connectedLoginPassword)
